import { timelineItems } from '@/mocks/home';

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">往期大瓜盘点</h2>
          <p className="mt-1 text-sm text-foreground-600">按时间倒序回看，热点脉络一次补齐</p>
        </div>

        <div className="relative pl-6 md:pl-8">
          <span className="absolute bottom-3 left-[7px] top-3 w-px bg-background-300 md:left-[9px]"></span>
          <ul className="space-y-4">
            {timelineItems.map((item) => (
              <li key={item.date} className="relative">
                <span className="absolute -left-6 top-5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-50 bg-accent-500 md:-left-8"></span>
                <a
                  href="#feed"
                  className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 hover:border-primary-300 md:flex-row md:items-center md:gap-5 md:p-5"
                >
                  <span className="font-heading text-xl font-bold text-primary-600 md:w-20 md:text-2xl">{item.date}</span>
                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center gap-2">
                      <span className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700 md:text-lg">
                        {item.title}
                      </span>
                      <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">{item.tag}</span>
                    </span>
                    <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{item.desc}</span>
                  </span>
                  <i className="ri-arrow-right-up-line hidden text-lg text-foreground-400 group-hover:text-primary-600 md:block"></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}